export const PNCP_CADASTRO_BASE_URL = 'https://pncp.gov.br/api/pncp/v1';

export const PNCP_CADASTRO_OPENAPI_URL = 'https://pncp.gov.br/api/pncp/v3/api-docs';

export const PNCP_OPENAPI_URL = PNCP_CADASTRO_OPENAPI_URL;

export const PNCP_CONSULTA_BASE_URL = 'https://pncp.gov.br/api/consulta';

export const PNCP_CONSULTA_OPENAPI_URL = 'https://pncp.gov.br/api/consulta/v3/api-docs';

export const PNCP_CONSULTA_SWAGGER_URL = 'https://pncp.gov.br/api/consulta/swagger-ui/index.html';

export const PNCP_GOLDEN_MODALIDADE_ID = 6;

export const PNCP_GOLDEN_MODALIDADE_NAME = 'Pregão - Eletrônico';

export const PNCP_ADAPTER_PACKAGE = '@br-validators/adapters-pncp';
